import { BuiltInAttribute } from "@orsane/schema/tasks";
import type { ColumnDef } from "../ColumnModel";
import type { Row } from "../RowModel";

export function buildTaskNumberColumn(isVisible: boolean): ColumnDef {
    return {
        id: BuiltInAttribute.id,
        header: "ID",
        isVisible: isVisible,
        cssColDef: "100px",
        isRight: false,
        isReadOnly: true,
        getSortValue: ({ row }: { row: Row }) => {
            return row.data.number;
        },
        getGroupHeader: ({ row }: { row: Row }) => {
            return `T-${row.data.number}`;
        },
        cell: ({ row }: { row: Row }) => {
            if (row.data.isNewlyCreated) {
                return null;
            }
            return <div className="text-sm flex items-center px-3 h-full tabular-nums">T-{row.data.number}</div>;
        },
    };
}
